module.exports = __webpack_public_path__ + "img/placeholder.26cddfa0.svg";